import { createContext, useContext, useState, useCallback, useEffect } from "react";

const translations = {
  es: {
    brand: "URBIS USA",
    nav_directory: "Directorio",
    nav_categories: "Categorías",
    nav_pricing: "Precios",
    nav_login: "Iniciar sesión",
    nav_register: "Registrarse",
    nav_dashboard: "Panel",
    nav_logout: "Cerrar sesión",
    dash_more: "Más",
    dash_menu: "Menú",
    dash_site: "Mi Página Web",
    dash_leads: "Solicitudes",
    dash_notifications: "Notificaciones",
    dash_messages: "Mensajes",
    new_pro: "Nuevo",
    chat_no_convs: "Sin conversaciones.",
    chat_select: "Selecciona una conversación",
    chat_reply_ph: "Escribe una respuesta…",
    chat_send_error: "No se pudo enviar el mensaje. Intenta de nuevo.",
    hero_tag: "Directorio de servicios · Estados Unidos",
    hero_title: "Encuentra profesionales de confianza para tu hogar y negocio",
    hero_sub: "Plomería, pintura, techos, remodelación, limpieza, belleza y mucho más. Conecta con expertos locales en tu ciudad.",
    hero_cta: "Buscar servicios",
    hero_cta2: "Registrar mi negocio",
    search_city: "Ciudad",
    search_state: "Estado",
    search_category: "Categoría",
    search_btn: "Buscar",
    search_placeholder: "Buscar por nombre...",
    all_categories: "Todas las categorías",
    popular_categories: "Categorías populares",
    featured: "Negocios destacados",
    featured_geo_note: "Cerca de ti, según tu ubicación",
    use_location: "Usar mi ubicación",
    how_title: "Cómo funciona",
    how_1_t: "Busca",
    how_1_d: "Encuentra profesionales por ciudad y categoría.",
    how_2_t: "Conecta",
    how_2_d: "Contacta directamente al negocio que necesitas.",
    how_3_t: "Resuelve",
    how_3_d: "Mejora tu propiedad con expertos verificados.",
    grow_title: "¿Tienes un negocio de servicios?",
    grow_sub: "Únete a nuestro directorio, gestiona clientes, factura con tu logo y administra tus proyectos y empleados.",
    grow_cta: "Empezar ahora",
    view_profile: "Ver perfil",
    contact: "Contactar",
    no_results: "No se encontraron negocios. Prueba con otra búsqueda.",
    footer_rights: "Todos los derechos reservados.",
    // auth
    login_title: "Iniciar sesión",
    register_title: "Crear cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    account_type: "Tipo de cuenta",
    client: "Cliente",
    business: "Negocio",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    // dashboard
    dash_overview: "Resumen",
    dash_profile: "Mi Negocio",
    dash_gallery: "Galería",
    dash_clients: "Clientes",
    dash_invoices: "Facturas",
    dash_receivables: "Cuentas",
    dash_projects: "Proyectos",
    dash_profitability: "Rentabilidad",
    dash_timesheets: "Horas",
    dash_payroll: "Nómina",
    dash_accounting: "Contabilidad",
    sort_by: "Ordenar por",
    sort_rating: "Mejor calificados",
    sort_reviews: "Más reseñas",
    sort_newest: "Más recientes",
    sort_name: "Nombre (A-Z)",
    suggested_label: "Sugeridas",
    dash_employees: "Empleados",
    dash_subscription: "Suscripción",
    save: "Guardar",
    add: "Agregar",
    delete: "Eliminar",
    edit: "Editar",
    cancel: "Cancelar",
    create: "Crear",
    status: "Estado",
    total: "Total",
    paid: "Pagada",
    pending: "Pendiente",
    commission: "Comisión",
    admin: "Administración",
  },
  en: {
    brand: "URBIS USA",
    nav_directory: "Directory",
    nav_categories: "Categories",
    nav_pricing: "Pricing",
    nav_login: "Log in",
    nav_register: "Sign up",
    nav_dashboard: "Dashboard",
    nav_logout: "Log out",
    dash_more: "More",
    dash_menu: "Menu",
    dash_site: "My Website",
    dash_leads: "Requests",
    dash_notifications: "Notifications",
    dash_messages: "Messages",
    new_pro: "New",
    chat_no_convs: "No conversations yet.",
    chat_select: "Select a conversation",
    chat_reply_ph: "Type a reply…",
    chat_send_error: "Message could not be sent. Try again.",
    hero_tag: "Service directory · United States",
    hero_title: "Find trusted professionals for your home and business",
    hero_sub: "Plumbing, painting, roofing, remodeling, cleaning, beauty and much more. Connect with local experts in your city.",
    hero_cta: "Find services",
    hero_cta2: "List my business",
    search_city: "City",
    search_state: "State",
    search_category: "Category",
    search_btn: "Search",
    search_placeholder: "Search by name...",
    all_categories: "All categories",
    popular_categories: "Popular categories",
    featured: "Featured businesses",
    featured_geo_note: "Near you, based on your location",
    use_location: "Use my location",
    how_title: "How it works",
    how_1_t: "Search",
    how_1_d: "Find professionals by city and category.",
    how_2_t: "Connect",
    how_2_d: "Contact the business you need directly.",
    how_3_t: "Solve",
    how_3_d: "Improve your property with verified experts.",
    grow_title: "Own a service business?",
    grow_sub: "Join our directory, manage clients, invoice with your logo and run your projects and employees.",
    grow_cta: "Get started",
    view_profile: "View profile",
    contact: "Contact",
    no_results: "No businesses found. Try another search.",
    footer_rights: "All rights reserved.",
    login_title: "Log in",
    register_title: "Create account",
    email: "Email",
    password: "Password",
    name: "Name",
    account_type: "Account type",
    client: "Client",
    business: "Business",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    dash_overview: "Overview",
    dash_profile: "My Business",
    dash_gallery: "Gallery",
    dash_clients: "Clients",
    dash_invoices: "Invoices",
    dash_receivables: "AR / AP",
    dash_projects: "Projects",
    dash_profitability: "Profitability",
    dash_timesheets: "Timesheets",
    dash_payroll: "Payroll",
    dash_accounting: "Accounting",
    sort_by: "Sort by",
    sort_rating: "Top rated",
    sort_reviews: "Most reviews",
    sort_newest: "Newest",
    sort_name: "Name (A-Z)",
    suggested_label: "Suggested",
    dash_employees: "Employees",
    dash_subscription: "Subscription",
    save: "Save",
    add: "Add",
    delete: "Delete",
    edit: "Edit",
    cancel: "Cancel",
    create: "Create",
    status: "Status",
    total: "Total",
    paid: "Paid",
    pending: "Pending",
    commission: "Commission",
    admin: "Admin",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  const [brand, setBrand] = useState(() => localStorage.getItem("brand_name") || translations.es.brand);
  const [logo, setLogo] = useState(() => localStorage.getItem("brand_logo") || "");
  const [siteUrl, setSiteUrl] = useState(() => localStorage.getItem("brand_site") || "");
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/branding`)
      .then((r) => r.json())
      .then((d) => {
        if (!d) return;
        if (d.brand_name) {
          setBrand(d.brand_name);
          localStorage.setItem("brand_name", d.brand_name);
          document.title = d.brand_name;
        }
        setLogo(d.logo_url || "");
        if (d.logo_url) localStorage.setItem("brand_logo", d.logo_url); else localStorage.removeItem("brand_logo");
        setSiteUrl(d.site_url || "");
        if (d.site_url) localStorage.setItem("brand_site", d.site_url); else localStorage.removeItem("brand_site");
        if (d.favicon_url) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
          link.href = d.favicon_url;
        }
      })
      .catch(() => {});
  }, []);
  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "es" ? "en" : "es";
      localStorage.setItem("lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => (key === "brand" ? brand : (translations[lang][key] ?? key)), [lang, brand]);
  const catLabel = useCallback((cat) => (lang === "es" ? cat.es : cat.en), [lang]);
  const bizName = useCallback((b) => {
    if (!b) return "";
    const n = b.name || "";
    if (!b.is_master) return n;
    return lang === "en" ? n.replace(/Servicios/g, "Services") : n.replace(/Services/g, "Servicios");
  }, [lang]);
  const bizDesc = useCallback((b) => {
    if (!b) return "";
    if (b.is_master) return lang === "es"
      ? "Cuéntanos qué servicio necesitas y te conectamos con profesionales verificados en tu ciudad."
      : "Tell us what service you need and we'll connect you with verified professionals in your city.";
    return b.description || "";
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, t, toggle, catLabel, bizName, bizDesc, logo, siteUrl }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);

